module.exports = __webpack_public_path__ + "img/for-kids-3.ddd37fc.webp";